import { render } from "./SportsBetPage.vue?vue&type=template&id=c27d9bda&scoped=true"
import script from "./SportsBetPage.vue?vue&type=script&lang=js"
export * from "./SportsBetPage.vue?vue&type=script&lang=js"

import "./SportsBetPage.vue?vue&type=style&index=0&id=c27d9bda&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27d9bda"]])

export default __exports__